/*
 * Endgame — mobile sticky add-to-pack bar (snippets/eg-buy-box-add-sticky.liquid).
 * Mirrors the buy-box button/picker; Dawn owns the variant state.
 */
(function () {
  function init(root) {
    const sectionId = root.dataset.section;
    const form = document.getElementById('product-form-' + sectionId);
    const stickyAdd = root.querySelector('[data-eg-sticky-add]');
    if (!form || !stickyAdd) return;

    const realAdd = form.querySelector('[name="add"]');
    if (!realAdd) return;

    const stickyLabel = stickyAdd.querySelector('span');
    const stickySpinner = stickyAdd.querySelector('.loading-overlay__spinner');
    const realSpinner = realAdd.querySelector('.loading-overlay__spinner');
    const stickySelect = root.querySelector('[data-eg-sticky-option]');
    const picker =
      document.getElementById('variant-radios-' + sectionId) ||
      document.getElementById('variant-selects-' + sectionId);

    /* ── Reveal once the real button has scrolled off the top ──
       Polled rather than observed: IntersectionObserver only reports threshold
       crossings, so a jump-scroll (in-page anchor, restored position) past the
       button never fires one. */
    const anchor = realAdd.closest('.eg-hero__addbar') || realAdd;
    let ticking = false;

    function update() {
      ticking = false;
      const visible = anchor.getBoundingClientRect().bottom <= 0;
      root.classList.toggle('is-visible', visible);
      document.body.classList.toggle('eg-buy-box-add-sticky-on', visible);
    }

    function onScroll() {
      if (ticking) return;
      window.requestAnimationFrame(update);
      ticking = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    /* ── Mirror the real button's label, sold-out and submit state ──
       product-form.js only knows about the button inside <product-form>, so
       the loading class and spinner have to be copied across by hand. */
    function syncButton() {
      stickyAdd.disabled = realAdd.hasAttribute('disabled');
      // ARIA wants the literal string, so toggleAttribute's "" is no good here.
      if (realAdd.getAttribute('aria-disabled') === 'true') {
        stickyAdd.setAttribute('aria-disabled', 'true');
      } else {
        stickyAdd.removeAttribute('aria-disabled');
      }
      stickyAdd.classList.toggle('loading', realAdd.classList.contains('loading'));
      if (realSpinner && stickySpinner) {
        stickySpinner.classList.toggle('hidden', realSpinner.classList.contains('hidden'));
      }
      const realLabel = realAdd.querySelector('span');
      if (realLabel && stickyLabel) stickyLabel.textContent = realLabel.textContent;
    }

    new MutationObserver(syncButton).observe(realAdd, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
      characterData: true,
    });
    syncButton();

    /* ── Two-way sync with the buy-box picker ──
       Matched on the option's name, not the value: a product can carry the
       same value under two options. */
    if (!stickySelect || !picker) return;
    const optionName = stickySelect.dataset.egOptionName;

    function realControls() {
      const selects = [...picker.querySelectorAll('select')];
      const select = selects.find((s) => s.name === 'options[' + optionName + ']') || null;
      const radios = [...picker.querySelectorAll('input[type="radio"]')].filter(
        (r) => r.name === optionName
      );
      return { select, radios };
    }

    stickySelect.addEventListener('change', function () {
      const { select, radios } = realControls();
      if (select) {
        select.value = stickySelect.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      for (const radio of radios) {
        if (radio.value !== stickySelect.value) continue;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    });

    // Programmatic .value assignment fires no change event, so this cannot loop.
    picker.addEventListener('change', function () {
      const { select, radios } = realControls();
      const checked = radios.find((r) => r.checked);
      const value = select ? select.value : checked && checked.value;
      if (value) stickySelect.value = value;
    });
  }

  for (const root of document.querySelectorAll('.eg-buy-box-add-sticky')) init(root);
})();
